(() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __moduleCache = /* @__PURE__ */ new WeakMap;
  var __toCommonJS = (from) => {
    var entry = __moduleCache.get(from), desc;
    if (entry)
      return entry;
    entry = __defProp({}, "__esModule", { value: true });
    if (from && typeof from === "object" || typeof from === "function")
      __getOwnPropNames(from).map((key) => !__hasOwnProp.call(entry, key) && __defProp(entry, key, {
        get: () => from[key],
        enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
      }));
    __moduleCache.set(from, entry);
    return entry;
  };
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, {
        get: all[name],
        enumerable: true,
        configurable: true,
        set: (newValue) => all[name] = () => newValue
      });
  };

  // js/scripts.ts
  var exports_scripts = {};
  __export(exports_scripts, {
    default: () => scripts_default
  });

  // ../lyquix/js/lib/scripts/core.ts
  var vars = {};
  var cfg = {};

  // js/custom/prefix.js
  var style = typeof document != "undefined" ? document.createElement("p").style : {};
  var prefixes = ["O", "ms", "Moz", "Webkit"];
  var upper = /([A-Z])/g;
  var memo = {};
  function prefix(e) {
    if (style[e = e.replace(/-([a-z])/g, function(e2, r2) {
      return r2.toUpperCase();
    })] !== undefined)
      return e;
    for (var r = e.charAt(0).toUpperCase() + e.slice(1), p = prefixes.length;p--; ) {
      var t = prefixes[p] + r;
      if (style[t] !== undefined)
        return t;
    }
    return e;
  }
  function prefixMemozied(e) {
    return e in memo ? memo[e] : memo[e] = prefix(e);
  }
  function prefixDashed(e) {
    return e = prefix(e), upper.test(e) && (e = "-" + e.replace(upper, "-$1"), upper.lastIndex = 0), e.toLowerCase();
  }
  var prefix_1 = prefixMemozied;
  var dash = prefixDashed;
  prefix_1.dash = dash;
  var prefix_default = prefix_1;

  // js/custom/normalize-wheel.js
  var _ie;
  var _firefox;
  var _opera;
  var _webkit;
  var _chrome;
  var _ie_real_version;
  var _osx;
  var _windows;
  var _linux;
  var _android;
  var _win64;
  var _iphone;
  var _ipad;
  var _native;
  var _mobile;
  var useHasFeature;
  var _populated = false;
  function _populate() {
    if (!_populated) {
      _populated = true;
      var e = navigator.userAgent, n = /(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))|(?:Trident\/\d+\.\d+.*rv:(\d+\.\d+))/.exec(e), i = /(Mac OS X)|(Windows)|(Linux)/.exec(e);
      if (_iphone = /\b(iPhone|iP[ao]d)/.exec(e), _ipad = /\b(iP[ao]d)/.exec(e), _android = /Android/i.exec(e), _native = /FBAN\/\w+;/i.exec(e), _mobile = /Mobile/i.exec(e), _win64 = !!/Win64/.exec(e), n) {
        (_ie = n[1] ? parseFloat(n[1]) : n[5] ? parseFloat(n[5]) : NaN) && document && document.documentMode && (_ie = document.documentMode);
        var t = /(?:Trident\/(\d+.\d+))/.exec(e);
        _ie_real_version = t ? parseFloat(t[1]) + 4 : _ie, _firefox = n[2] ? parseFloat(n[2]) : NaN, _opera = n[3] ? parseFloat(n[3]) : NaN, _chrome = (_webkit = n[4] ? parseFloat(n[4]) : NaN) && (n = /(?:Chrome\/(\d+\.\d+))/.exec(e)) && n[1] ? parseFloat(n[1]) : NaN;
      } else
        _ie = _firefox = _opera = _chrome = _webkit = NaN;
      if (i) {
        if (i[1]) {
          var o = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(e);
          _osx = !o || parseFloat(o[1].replace("_", "."));
        } else
          _osx = false;
        _windows = !!i[2], _linux = !!i[3];
      } else
        _osx = _windows = _linux = false;
    }
  }
  var UserAgent_DEPRECATED = { ie: function() {
    return _populate() || _ie;
  }, ieCompatibilityMode: function() {
    return _populate() || _ie_real_version > _ie;
  }, ie64: function() {
    return UserAgent_DEPRECATED.ie() && _win64;
  }, firefox: function() {
    return _populate() || _firefox;
  }, opera: function() {
    return _populate() || _opera;
  }, webkit: function() {
    return _populate() || _webkit;
  }, safari: function() {
    return UserAgent_DEPRECATED.webkit();
  }, chrome: function() {
    return _populate() || _chrome;
  }, windows: function() {
    return _populate() || _windows;
  }, osx: function() {
    return _populate() || _osx;
  }, linux: function() {
    return _populate() || _linux;
  }, iphone: function() {
    return _populate() || _iphone;
  }, mobile: function() {
    return _populate() || _iphone || _ipad || _android || _mobile;
  }, nativeApp: function() {
    return _populate() || _native;
  }, android: function() {
    return _populate() || _android;
  }, ipad: function() {
    return _populate() || _ipad;
  } };
  var UserAgent_DEPRECATED_1 = UserAgent_DEPRECATED;
  var canUseDOM = !!(typeof window != "undefined" && window.document && window.document.createElement);
  var ExecutionEnvironment = { canUseDOM, canUseWorkers: typeof Worker != "undefined", canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent), canUseViewport: canUseDOM && !!window.screen, isInWorker: !canUseDOM };
  var ExecutionEnvironment_1 = ExecutionEnvironment;
  function isEventSupported(e, n) {
    if (!ExecutionEnvironment_1.canUseDOM || n && !("addEventListener" in document))
      return false;
    var i = "on" + e, t = i in document;
    if (!t) {
      var o = document.createElement("div");
      o.setAttribute(i, "return;"), t = typeof o[i] == "function";
    }
    return !t && useHasFeature && e === "wheel" && (t = document.implementation.hasFeature("Events.wheel", "3.0")), t;
  }
  ExecutionEnvironment_1.canUseDOM && (useHasFeature = document.implementation && document.implementation.hasFeature && document.implementation.hasFeature("", "") !== true);
  var isEventSupported_1 = isEventSupported;
  var PIXEL_STEP = 10;
  var LINE_HEIGHT = 40;
  var PAGE_HEIGHT = 800;
  function normalizeWheel(e) {
    var n = 0, i = 0, t = 0, o = 0;
    return "detail" in e && (i = e.detail), "wheelDelta" in e && (i = -e.wheelDelta / 120), "wheelDeltaY" in e && (i = -e.wheelDeltaY / 120), "wheelDeltaX" in e && (n = -e.wheelDeltaX / 120), "axis" in e && e.axis === e.HORIZONTAL_AXIS && (n = i, i = 0), t = n * PIXEL_STEP, o = i * PIXEL_STEP, "deltaY" in e && (o = e.deltaY), "deltaX" in e && (t = e.deltaX), (t || o) && e.deltaMode && (e.deltaMode == 1 ? (t *= LINE_HEIGHT, o *= LINE_HEIGHT) : (t *= PAGE_HEIGHT, o *= PAGE_HEIGHT)), t && !n && (n = t < 1 ? -1 : 1), o && !i && (i = o < 1 ? -1 : 1), { spinX: n, spinY: i, pixelX: t, pixelY: o };
  }
  normalizeWheel.getEventType = function() {
    return UserAgent_DEPRECATED_1.firefox() ? "DOMMouseScroll" : isEventSupported_1("wheel") ? "wheel" : "mousewheel";
  };
  var normalizeWheel_1 = normalizeWheel;
  var normalizeWheel$1 = normalizeWheel_1;
  var normalize_wheel_default = normalizeWheel$1;

  // js/custom/scripts/home.ts
  var home = (() => {
    const init = (customCfg) => {
      if (vars.home?.init)
        return;
      vars.home = {
        init: false
      };
      cfg.home = {
        enabled: true
      };
      if (customCfg)
        cfg.home = jQuery.extend(true, cfg.home, customCfg);
      if (cfg.home.enabled) {
        lqx.log("Initializing home");
        if (jQuery("body.home").length) {
          homeAnimation();
        }
      }
      vars.home.init = true;
    };
    const homeAnimation = function() {
      gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
      ScrollTrigger.defaults({
        scroller: ".wrapper"
      });

      class App {
        constructor() {
          this.wrapper = document.querySelector(".wrapper");
          this.scroll = {
            current: 0,
            target: 0,
            limit: 0
          };
          this.transformPrefix = prefix_default("transform");
          this.resizeTimeout = null;
          this.touchStart = null;
          this.lastTouchY = null;
          this.touchVelocity = 0;
          this.pullThreshold = 80;
          this.addEventListeners();
          this.init();
          this.update();
        }
        addEventListeners() {
          window.addEventListener("wheel", this.onWheel.bind(this), { passive: false });
          window.addEventListener("touchstart", this.onTouchStart.bind(this), { passive: false });
          window.addEventListener("touchmove", this.onTouchMove.bind(this), { passive: false });
          window.addEventListener("touchend", this.onTouchEnd.bind(this), { passive: false });
          window.addEventListener("resize", this.onResize.bind(this), { passive: false });
          window.addEventListener("keydown", this.onKeyDown.bind(this));
        }
        onWheel(event) {
          const normalizedWheel = normalize_wheel_default(event);
          this.scroll.target += normalizedWheel.pixelY;
        }
        onKeyDown(event) {
          if (event.key === "PageUp") {
            this.scroll.target -= window.innerHeight;
            event.preventDefault();
          } else if (event.key === "PageDown") {
            this.scroll.target += window.innerHeight;
            event.preventDefault();
          }
          this.scroll.target = gsap.utils.clamp(0, this.scroll.limit, this.scroll.target);
        }
        onTouchStart(event) {
          const header = document.querySelector("header");
          if (header && header.classList.contains("mobile-menu-open")) {
            return;
          }
          this.touchStart = event.touches[0].clientY;
          this.lastTouchY = this.touchStart;
          this.touchVelocity = 0;
        }
        onTouchMove(event) {
          const header = document.querySelector("header");
          if (header.classList.contains("mobile-menu-open")) {
            return;
          }
          if (this.touchStart === null)
            return;
          const currentY = event.touches[0].clientY;
          const delta = this.lastTouchY - currentY;
          this.scroll.target += delta;
          this.touchVelocity = delta;
          this.lastTouchY = currentY;
          event.preventDefault();
        }
        onTouchEnd(event) {
          if (this.touchStart !== null) {
            const pullDistance = this.lastTouchY - this.touchStart;
            if (this.scroll.current === 0 && pullDistance > this.pullThreshold) {
              location.reload();
              this.touchStart = null;
              return;
            }
          }
          if (jQuery(".panel.bottom-box").hasClass("active")) {
            gsap.to(this.scroll, {
              target: this.scroll.target + this.touchVelocity * 40,
              ease: "power2.out",
              duration: 1,
              onUpdate: () => {
                this.scroll.target = gsap.utils.clamp(0, this.scroll.limit, this.scroll.target);
              }
            });
          }
        }
        init() {
          this.scroll.limit = this.wrapper.clientHeight - window.innerHeight;
        }
        onResize() {
          ScrollTrigger.getAll().forEach((trigger) => trigger.disable());
          this.scroll.limit = this.wrapper.clientHeight - window.innerHeight;
          clearTimeout(this.resizeTimeout);
          this.resizeTimeout = setTimeout(() => {
            ScrollTrigger.getAll().forEach((trigger) => trigger.enable());
          }, 500);
        }
        update() {
          this.scroll.target = gsap.utils.clamp(0, this.scroll.limit, this.scroll.target);
          this.scroll.current = gsap.utils.interpolate(this.scroll.current, this.scroll.target, 0.2);
          if (this.scroll.current < 0.01) {
            this.scroll.current = 0;
          }
          this.wrapper.style[this.transformPrefix] = `translateY(-${this.scroll.current}px)`;
          ScrollTrigger.update();
          window.requestAnimationFrame(this.update.bind(this));
        }
      }
      const app = new App;
      ScrollTrigger.scrollerProxy(".wrapper", {
        scrollTop(value) {
          if (arguments.length) {
            app.scroll.current = value;
          }
          return app.scroll.current;
        },
        getBoundingClientRect() {
          return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
        }
      });
      jQuery(function($) {
        let sections = gsap.utils.toArray(".panel");
        let $overlay = $(".top-panel.first-panel .overlay");
        let $texts = $(".animated-text");
        let arrow = $(".top-panel .arrow");
        let bgClasses = ["bg-overlay-green", "bg-overlay-yellow", "bg-overlay-teal"];
        let currentPanel = 0;
        ScrollTrigger.create({
          trigger: ".top-panel:first-child",
          start: "top top",
          end: "+=200%",
          pin: "video",
          scroller: ".wrapper"
        });
        const video = document.querySelector("video");
        let tl1 = gsap.timeline({});
        video.load();
        video.addEventListener("canplaythrough", function() {
          $(".top-panel").addClass("loaded");
          $texts.each((i, text) => {
            tl1.call(() => updateTextAnimation(i)).to({}, { duration: 2.5 });
          });
          $(".top-text").show();
          video.play();
        }, { once: true });
        function updateTextAnimation(index) {
          $(".initial-text").addClass("active");
          let newBg = bgClasses[index % bgClasses.length];
          $overlay.removeClass(bgClasses.join(" ")).addClass(newBg);
          $texts.removeClass("active");
          $texts.eq(index).addClass("active");
          animateText(".animated-text.active .char");
          if (index === $texts.length - 1) {
            arrow.addClass("active");
          }
        }
        arrow.click(() => goToSection(sections[1]));
        function goToSection(panel, index = null, back = null) {
          let pinned = $(panel).hasClass("pinned-panel");
          if (index === 0 && back)
            tl1.restart();
          if (index > 0)
            tl1.kill();
          const offsetY = index === sections.length - 1 ? 70 : 0;
          const targetScroll = panel.offsetTop - offsetY;
          $(".panel").removeClass("active");
          $(panel).addClass("active");
          $(".panel").find(".logo-wrapper").css("top", "");
          if (index == sections.length - 1 && back)
            return;
          gsap.to(app.scroll, {
            target: targetScroll,
            duration: pinned && back ? 0.8 : 0.5
          });
          currentPanel = index;
          if ($(panel).hasClass("card")) {
            const offset = $(panel).find(".side-media").outerHeight();
            const target = $(panel).find(".logo-wrapper");
            $(target).css("top", offset);
          }
        }
        $(document).on("click", ".arrow-down", function() {
          let index = currentPanel + 1;
          goToSection(sections[index], index);
        });
        $(document).on("click", ".arrow-up", function() {
          let index = currentPanel - 1;
          let back = !currentPanel;
          goToSection(sections[index], index, back);
        });
        sections.forEach((eachPanel, index) => {
          let offset = index === sections.length ? 71 : 0;
          let start = "top bottom-=5";
          let end = "bottom top+=5";
          let innerPinned = eachPanel.querySelector(".inner-pinned, .inner-pinned-grid");
          ScrollTrigger.create({
            trigger: eachPanel,
            start,
            end,
            onEnter: () => goToSection(eachPanel, index),
            onEnterBack: () => goToSection(eachPanel, index, true),
            onUpdate: () => {
              if (!index)
                $overlay.removeClass(bgClasses.join(" ")).addClass("bg-overlay-green");
            },
            scroller: ".wrapper"
          });
          ScrollTrigger.create({
            trigger: eachPanel,
            start: "top top",
            end: "bottom bottom",
            pin: innerPinned,
            scroller: ".wrapper"
          });
        });
        function animateText(target) {
          gsap.from(target, {
            y: "100%",
            opacity: 0,
            duration: 0.2,
            stagger: 0.05
          });
        }
        function splitText(selector) {
          document.querySelectorAll(selector).forEach((el) => {
            const words = el.textContent.split(/\s+/);
            el.innerHTML = words.map((word) => `<span class="word-wrapper"><span class="word">
                        ${[...word].map((char) => `<span class="char">${char}</span>`).join("")}
                    </span></span>`).join('<span class="whtSpc"> </span>');
          });
        }
        splitText(".splt");
      });
    };
    return {
      init
    };
  })();

  // js/custom/scripts/menu.ts
  var menu = (() => {
    const init = (customCfg) => {
      if (vars.menu?.init)
        return;
      vars.menu = {
        init: false
      };
      cfg.menu = {
        enabled: true
      };
      if (customCfg)
        cfg.menu = jQuery.extend(true, cfg.menu, customCfg);
      if (cfg.menu.enabled) {
        lqx.log("Initializing menu");
        megaMenu();
      }
      vars.menu.init = true;
    };
    const megaMenu = function() {
      jQuery(".has-mega-menu.menu-item > .right-arrow, .has-mega-menu.menu-item > button").click(function(e) {
        if (window.innerWidth <= 719) {
          let parentLi = jQuery(this).parent();
          let megaMenu2 = parentLi.find(".mega-menu");
          let allMenus = jQuery(".mega-menu");
          let allMenuItems = jQuery(".main-menu > li");
          if (parentLi.hasClass("active")) {
            allMenuItems.show();
            allMenus.hide();
            parentLi.removeClass("active");
          } else {
            allMenuItems.hide();
            parentLi.show();
            allMenus.hide();
            megaMenu2.show();
            parentLi.addClass("active");
          }
        }
      });
    };
    function toggleMegaMenu() {
      if (window.innerWidth >= 720) {
        jQuery(".main-menu > li").show();
        jQuery(".mega-menu").css("display", "");
        jQuery(".has-mega-menu").removeClass("active");
        jQuery("header").removeClass("mobile-menu-open");
      }
    }
    jQuery(window).resize(function() {
      toggleMegaMenu();
    });
    return {
      init
    };
  })();

  // js/custom/scripts/slideshow.ts
  var slideshow = (() => {
    const init = (customCfg) => {
      if (vars.slideshow?.init)
        return;
      vars.slideshow = {
        init: false
      };
      cfg.slideshow = {
        enabled: true
      };
      if (customCfg)
        cfg.slideshow = jQuery.extend(true, cfg.slideshow, customCfg);
      if (cfg.slideshow.enabled) {
        lqx.log("Initializing slideshow");
        if (jQuery("body.single-slideshow").length) {
          window.addEventListener("resize", scaleDiv);
          window.addEventListener("load", scaleDiv);
          var swiper = new Swiper(".swiper", {
            loop: false,
            slidesPerView: 1,
            on: {
              touchEnd: function() {
                this.allowTouchMove = true;
              },
              slideChange: function() {
                let slides = document.querySelectorAll(".swiper-slide");
                let video2 = document.querySelector(".swiper-slide:last-child video");
                if (video2) {
                  if (swiper.activeIndex === slides.length - 1) {
                    video2.play();
                  } else {
                    video2.pause();
                    video2.currentTime = 0;
                  }
                }
              }
            }
          });
          controls(swiper);
        }
      }
      vars.slideshow.init = true;
    };
    const video = document.querySelector("video");
    if (video !== null && jQuery("top-panel").length) {
      video.load();
      video.addEventListener("canplaythrough", function() {
        jQuery(".top-panel").addClass("loaded");
        video.play();
      }, { once: true });
    }
    function controls(swiper) {
      const nextBtn = document.querySelector(".next");
      const prevBtn = document.querySelector(".prev");
      const portfolioBtn = document.getElementById("portfolio");
      const homeButton = document.getElementById("homeButton");
      const fullscreenButton = document.getElementById("fullscreen-btn");
      updateNavButtons();
      fullscreenButton.addEventListener("click", toggleFullscreen);
      nextBtn.addEventListener("click", () => handleSlideNavigation(true));
      portfolioBtn.addEventListener("click", () => handleSlideNavigation(true));
      prevBtn.addEventListener("click", () => handleSlideNavigation(false));
      homeButton.addEventListener("click", () => {
        swiper.slideTo(0);
        jQuery(".project-item").removeClass("show-content");
      });
      document.addEventListener("keydown", function(e) {
        if (e.key === "ArrowRight") {
          handleSlideNavigation(true);
        } else if (e.key === "ArrowLeft") {
          handleSlideNavigation(false);
        }
      });
      swiper.on("touchStart", (swiperInstance, event) => {
        let startX;
        if (event.touches && event.touches.length > 0) {
          startX = event.touches[0].pageX;
        } else if (event.changedTouches && event.changedTouches.length > 0) {
          startX = event.changedTouches[0].pageX;
        } else {
          startX = event.pageX || event.clientX;
        }
        swiperInstance.initialTouchX = startX;
      });
      swiper.on("touchMove", (swiperInstance, event) => {
        const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
        if (activeSlide.classList.contains("project-item")) {
          let currentX;
          if (event.touches && event.touches.length > 0) {
            currentX = event.touches[0].pageX;
          } else if (event.changedTouches && event.changedTouches.length > 0) {
            currentX = event.changedTouches[0].pageX;
          } else {
            currentX = event.pageX || event.clientX;
          }
          const direction = swiperInstance.initialTouchX > currentX ? "next" : "prev";
          swiperInstance.allowTouchMove = false;
          if (direction === "next") {
            handleSlideNavigation(true);
          } else if (direction === "prev") {
            handleSlideNavigation(false);
          }
        }
      });
      swiper.on("touchEnd", (swiperInstance) => {
        swiperInstance.allowTouchMove = true;
      });
      function handleSlideNavigation(isNext) {
        const activeSlide = swiper.slides[swiper.activeIndex];
        if (activeSlide.classList.contains("project-item")) {
          if (isNext) {
            if (!activeSlide.classList.contains("show-content")) {
              activeSlide.classList.add("show-content");
              return;
            }
          } else {
            if (activeSlide.classList.contains("show-content")) {
              activeSlide.classList.remove("show-content");
              return;
            }
          }
        }
        if (isNext) {
          swiper.slideNext();
        } else {
          swiper.slidePrev();
        }
      }
      function updateNavButtons() {
        if (swiper.isBeginning) {
          prevBtn.classList.add("swiper-button-disabled");
        } else {
          prevBtn.classList.remove("swiper-button-disabled");
        }
        if (swiper.isEnd) {
          nextBtn.classList.add("swiper-button-disabled");
        } else {
          nextBtn.classList.remove("swiper-button-disabled");
        }
      }
      swiper.on("slideChange", () => {
        updateNavButtons();
      });
    }
    function scaleDiv() {
      let div = document.querySelector("article");
      let screenWidth = window.innerWidth;
      let screenHeight = window.innerHeight;
      let scaleFactor = Math.min(screenWidth / 1920, screenHeight / 1080);
      div.style.transform = `scale(${scaleFactor})`;
      div.classList.add("scaled");
    }
    function toggleFullscreen() {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen().catch((err) => {
          console.error(`Error attempting to enable fullscreen: ${err.message}`);
        });
      } else {
        document.exitFullscreen();
      }
    }
    jQuery("#howToUse").click(function() {
      jQuery("#howToUseModal").fadeIn();
    });
    jQuery(".close").click(function() {
      jQuery("#howToUseModal").fadeOut();
    });
    jQuery(window).click(function(event) {
      if (jQuery(event.target).is("#howToUseModal")) {
        jQuery("#howToUseModal").fadeOut();
      }
    });
    return {
      init
    };
  })();

  // js/scripts.ts
  var init = (customCfg) => {
    if (vars.init)
      return;
    if (typeof customCfg !== "object")
      customCfg = {};
    const mods = [
      "home",
      "menu",
      "slideshow"
    ];
    console.log("Initializing scripts");
    lqx.log("Custom configuration", customCfg);
    mods.forEach((mod) => {
      $lqx[mod].init(mod in customCfg ? customCfg[mod] : {});
    });
    lqx.vars.document.trigger("$lqxready");
    lqx.log("$lqxready Event");
    vars.init = true;
  };
  var ready = (callback) => {
    if (vars.init === true) {
      callback();
    } else {
      vars.document.on("$lqxready", callback);
    }
  };
  var expObj = Object.defineProperties({
    init,
    ready,
    home,
    menu,
    slideshow
  }, {
    cfg: {
      get() {
        return cfg;
      },
      set() {
        return;
      }
    },
    vars: {
      get() {
        return vars;
      },
      set() {
        return;
      }
    }
  });
  var scripts_default = expObj;
  if (typeof window !== "undefined") {
    window.$lqx = expObj;
  }
})();
